import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, DrawerItem, AdditionalNavItem, IconAsset } from '@sitebase/web-shell-kit';
import { Anchor } from '@sitebase/ui-kit';
import { RadioItem, Radio } from './radio';
import withRadio, { WH_RADIO_TYPE_RADIO } from '../withRadio';

export const RADIO_RENDERER_TYPE = '@sportsbook/radio';

export const RadioMenu = (props) => {
  const {
    id,
    label,
    items,
    icon,
    isNested,
    playing,
    playingLabel,
    marqueeText,
    animationOn,
    muted,
    onMuteToggle,
    onClickHandler,
  } = props;
  const NavItemWrapper = isNested ? DrawerItem : AdditionalNavItem;

  const additionalNavItemLabel = playing ? (
    <Radio
      label={marqueeText}
      playingLabel={playingLabel}
      animationOn={animationOn}
      onEqualizerClick={onMuteToggle}
      muted={muted}
    />
  ) : (
    label
  );

  return (
    <NavItemWrapper
      id={id}
      label={additionalNavItemLabel}
      icon={isNested && icon ? <IconAsset name={icon} /> : undefined}
      data-test-id={`${RADIO_RENDERER_TYPE}_${id}`}
    >
      {isNested && label}
      <Drawer data-test-id={`${RADIO_RENDERER_TYPE}.dropdown_${id}`}>
        {items.map((radioProps) => (
          <DrawerItem
            key={radioProps.id}
            icon={radioProps.icon ? <IconAsset name={radioProps.icon} /> : undefined}
            data-test-id={`${RADIO_RENDERER_TYPE}.item_${id}`}
            onClick={onClickHandler(radioProps)}
          >
            {radioProps.type === WH_RADIO_TYPE_RADIO ? (
              <RadioItem
                radio={radioProps}
                active={radioProps.label === playingLabel}
                muted={muted}
                onEqualizerClick={onMuteToggle}
                data-test-id={`${RADIO_RENDERER_TYPE}.stream-item_${id}`}
              />
            ) : (
              <Anchor outfit="inherit" data-test-id={`${RADIO_RENDERER_TYPE}.link-item_${id}`}>
                {radioProps.label}
              </Anchor>
            )}
          </DrawerItem>
        ))}
      </Drawer>
    </NavItemWrapper>
  );
};

const radioStreamPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  streamUrl: PropTypes.string.isRequired,
  marqueeText: PropTypes.string,
});

const radioLinkPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  target: PropTypes.string,
});

const dataPropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  isNested: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.oneOfType([radioStreamPropType, radioLinkPropType])),
  playing: PropTypes.bool,
  playingLabel: PropTypes.string,
  marqueeText: PropTypes.string,
  animationOn: PropTypes.bool,
  muted: PropTypes.bool,
  onMuteToggle: PropTypes.func,
  onClickHandler: PropTypes.func,
};
RadioMenu.propTypes = dataPropTypes;

RadioMenu.defaultProps = {
  isNested: false,
};

const renderFunction = ({ data }) => {
  const Menu = withRadio(RadioMenu, {
    forwardedKey: data.id,
    ...data,
  });
  return <Menu key={data.id} />;
};

renderFunction.propTypes = {
  data: PropTypes.shape(dataPropTypes),
};
const buildRadioMenuRenderer = () => ({
  type: RADIO_RENDERER_TYPE,
  render: renderFunction,
  schema: {},
});

const RadioMenuRenderer = buildRadioMenuRenderer();

export default RadioMenuRenderer;
